/**
 * @generated SignedSource<<6de58dc56134155dea12c557560d17f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useStartCheckoutMutation$variables = {
  ignorePriceOnPlan?: boolean | null;
  inviteToken?: string | null;
  occurrenceId?: string | null;
  productId: string;
};
export type useStartCheckoutMutation$data = {
  readonly createCheckout: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CheckoutStore_Checkout">;
    } | null;
  };
};
export type useStartCheckoutMutation = {
  response: useStartCheckoutMutation$data;
  variables: useStartCheckoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ignorePriceOnPlan"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inviteToken"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "occurrenceId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "ignorePriceOnPlan",
    "variableName": "ignorePriceOnPlan"
  },
  {
    "kind": "Variable",
    "name": "inviteToken",
    "variableName": "inviteToken"
  },
  {
    "kind": "Variable",
    "name": "occurrenceId",
    "variableName": "occurrenceId"
  },
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckoutQuestion",
    "kind": "LinkedField",
    "name": "questions",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "richEditorBody",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "answers",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useStartCheckoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateCheckoutResponse",
        "kind": "LinkedField",
        "name": "createCheckout",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Checkout",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CheckoutStore_Checkout"
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useStartCheckoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateCheckoutResponse",
        "kind": "LinkedField",
        "name": "createCheckout",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Checkout",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pricing",
                    "kind": "LinkedField",
                    "name": "pricing",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "frequency",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amountCents",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "viewerActiveMembershipPlan",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuote",
                "kind": "LinkedField",
                "name": "quote",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "basePrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "finalPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Discount",
                    "kind": "LinkedField",
                    "name": "discount",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueKind",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueAmount",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuestionAnswers",
                "kind": "LinkedField",
                "name": "application",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuestionAnswers",
                "kind": "LinkedField",
                "name": "organizationForm",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasApplication",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOrganizationPublic",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezone",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Occurrence",
                "kind": "LinkedField",
                "name": "occurrence",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowGuestAccess",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Invitation",
                "kind": "LinkedField",
                "name": "invitation",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organizationId",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a83c52c064504c9b37e0393d27471e17",
    "id": null,
    "metadata": {},
    "name": "useStartCheckoutMutation",
    "operationKind": "mutation",
    "text": "mutation useStartCheckoutMutation(\n  $productId: ID!\n  $inviteToken: String\n  $occurrenceId: ID\n  $ignorePriceOnPlan: Boolean\n) {\n  createCheckout(productId: $productId, inviteToken: $inviteToken, occurrenceId: $occurrenceId, ignorePriceOnPlan: $ignorePriceOnPlan) {\n    node {\n      id\n      ...CheckoutStore_Checkout\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment CheckoutFormApplicationSection_Checkout on Checkout {\n  application {\n    questions {\n      id\n      richEditorBody\n    }\n  }\n}\n\nfragment CheckoutFormDiscountInput_Checkout on Checkout {\n  quote {\n    discount {\n      id\n      code\n    }\n  }\n}\n\nfragment CheckoutFormOrganizationFormSection_Checkout on Checkout {\n  organizationForm {\n    questions {\n      id\n      richEditorBody\n    }\n  }\n}\n\nfragment CheckoutStore_Checkout on Checkout {\n  id\n  ...ProductRegistrationPaymentStep_Checkout\n  ...ProductRegistrationProfileStep_Checkout\n  ...CheckoutFormDiscountInput_Checkout\n  ...CheckoutFormApplicationSection_Checkout\n  ...CheckoutFormOrganizationFormSection_Checkout\n  hasApplication\n  isOrganizationPublic\n  profile {\n    userId\n    email\n    firstName\n    lastName\n    timezone\n  }\n  quote {\n    basePrice\n    finalPrice\n    currency\n    discount {\n      id\n      code\n    }\n  }\n  occurrence {\n    id\n    allowGuestAccess\n  }\n  application {\n    answers\n  }\n  organizationForm {\n    answers\n  }\n  invitation {\n    kind\n    message\n    productId\n    organizationId\n    id\n  }\n}\n\nfragment Discount_displayValue on Discount {\n  valueKind\n  valueAmount\n}\n\nfragment PaymentFormDiscountSection_Discount on Discount {\n  ...Discount_displayValue\n}\n\nfragment PaymentFormDiscountSection_Pricing on Pricing {\n  frequency\n  ...pricingUtils_usePricingDisplayValue\n}\n\nfragment ProductRegistrationPaymentStep_Checkout on Checkout {\n  id\n  product {\n    type\n    pricing {\n      ...PaymentFormDiscountSection_Pricing\n      id\n    }\n    organization {\n      viewerActiveMembershipPlan {\n        id\n      }\n      id\n    }\n    id\n  }\n  quote {\n    basePrice\n    finalPrice\n    discount {\n      ...PaymentFormDiscountSection_Discount\n      id\n    }\n  }\n}\n\nfragment ProductRegistrationProfileStep_Checkout on Checkout {\n  id\n  product {\n    organization {\n      viewerActiveMembershipPlan {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment pricingUtils_usePricingDisplayValue on Pricing {\n  frequency\n  kind\n  amountCents\n}\n"
  }
};
})();

(node as any).hash = "5eacc8d92c78c76452ede7ac1b3bd84b";

export default node;
